import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { AccessOptions } from '@shared/models/accessOptions.model';
import { Personas } from '@shared/models/personas.model';
import { UserService } from '@shared/services/user.service';
import { HospitalService } from 'src/app/shared/services/hospital.service';
import { pages } from '../../shared/config/pages';
import { AuthenticationService } from './authentication.service';
import { NavigationService } from './navigation.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard implements CanActivate {
  constructor(
    private authenticationService: AuthenticationService,
    private storageService: StorageService,
    private hospitalService: HospitalService,
    private navigationService: NavigationService,
    private userService: UserService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    const isAuthenticated = this.authenticationService.isAuthenticated();
    if (isAuthenticated) {
      const fullscreenActivated = this.storageService.getData('fullscreenActivated');
      if (fullscreenActivated) {
        this.authenticationService.logout();
        this.navigationService.navigateByUrl(pages.login).catch();
        this.storageService.saveData('fullscreenActivated', false);
        return false;
      }

      const accessOptions = (this.userService.getCurrentUser().persona as Personas).accessOptions as AccessOptions[];
      const homeAccessOptions = accessOptions.find((accessOption: AccessOptions) => accessOption.isHome);
      const accessOptionsOfPage = this.userService.getAccessOptionsOfPage(state.url.replace('/history', ''));
      if (
        !accessOptionsOfPage &&
        !(this.userService.getCurrentUser().persona as Personas).isAdmin &&
        !state.url.includes('authentication')
      ) {
        if (homeAccessOptions && homeAccessOptions.pageUrl) {
          this.navigationService.navigateTo(homeAccessOptions.pageUrl);
          return false;
        } else {
          this.navigationService.navigateTo('access-denied');
          return false;
        }
      }

      if (route.data['neededOptions']) {
        for (const neededOption of route.data['neededOptions']) {
          if (!this.hospitalService.checkIfHospitalHaveOption(neededOption)) {
            return false;
          }
        }
      }
      return true;
    } else {
      this.storageService.saveData('fullscreenActivated', false);
      this.navigationService.navigateByUrl(pages.login).catch();
      return false;
    }
  }
}
